import * as React from 'react'
import { Map } from 'react-loadable'

export const prefetch = () =>
  import('./PricesPage')

export const PricesPage = Map({
  loader: {
    Module: prefetch
  },
  loading: () => null,
  render: ({ Module }, props) => <Module.default {...props} />
})



// WEBPACK FOOTER //
// ./src/routes/PricesPage/index.js